import { cn } from '@/utils/styles';
import { Card } from '@design-system/Card';
import { Link } from '@design-system/Link';
import { List, ListItem } from '@design-system/List';
import { linkoutConfigs } from '@/config/routing/LinkoutConfig';

export type SettingsPageSupportSectionProps = React.ComponentProps<'div'>;

export const SettingsPageSupportSection = ({
  className,
}: SettingsPageSupportSectionProps) => {

  const supportLinks = [
    {
      label: 'FAQs',
      to: linkoutConfigs.faqs,
    },
    {
      label: 'Contact Customer Service',
      to: linkoutConfigs.contact,
    },
    {
      label: 'Share Your Experience',
      to: linkoutConfigs.share,
    },
  ] as const;

  const isExternalLink = (url: string) => !url.startsWith('mailto:');

  return (
    <div className={cn('flex flex-col', className)}>
      <span className="typography-h2 text-primary mb-6">Support</span>

      <Card>
        <List>
          {supportLinks.map(({ label, to }) => (
            <ListItem key={label} asChild>
              <Link 
                to={to}
                {...(isExternalLink(to) && {
                  target: '_blank', 
                })}
              >
                {label}
              </Link>
            </ListItem>
          ))}
        </List>
      </Card>
    </div>
  );
};